const getters = {
  device: state => state.app.device,
  theme: state => state.app.theme,
  color: state => state.app.color
};

export default getters;
